import OptimizeExperiments from "connected-components/optimize-experiments"
import type { ModelMetadata } from "connected-components/optimize-experiments/types"

import "./styles.scss"

interface OptimizeExperimentsPanelProps {
  modelMetadata: ModelMetadata
  isOptimizedExperimentsEnabled: boolean
}

export default function OptimizeExperimentsPanel({
  modelMetadata,
  isOptimizedExperimentsEnabled,
}: OptimizeExperimentsPanelProps) {
  if (!isOptimizedExperimentsEnabled) {
    return null
  }

  return (
    <div className="optimizer-widget-panel visible">
      <OptimizeExperiments modelMetadata={modelMetadata} />
    </div>
  )
}
